


import 'dayjs/plugin/customParseFormat';
import { callApi } from '../../../utils/apiClient';
import { API_ENDPOINTS } from '../../../config/api/apiCall';


const LoadChildRollDetailsInQRCode = async (companyID, ChildRollNumber,viewQRCodeDetails,setViewQRCodeDetails,setSelectedChildRollDetails,setQRCodeValue) => {

    // load parameter details

    const orderData = {
        p_companyid: localStorage.getItem('companyid'),
        p_child_reel_number: ChildRollNumber,
    };

    callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_APPROVED_CHILD_ROLL_DETAIL, 'POST', { 'Content-Type': 'application/json' }, orderData)
        .then(data => {
            if (data && data.length > 0) {
                setViewQRCodeDetails(true);
                // setSelectedChildRollDetails(data[0]);

                setSelectedChildRollDetails({
                    ...data[0],
                    achieved_qty: Math.ceil(data[0].achieved_qty * 1000),                   
                });

                // const qrValue = `Child Roll No: ${data[0].child_reel_number || 'XXXXXX0123'}, ` +
                //     `Quality: ${data[0].item_code || 'XXXXQuality'}, ` +
                //     `Size: ${data[0].width || '0'} X ${data[0].length}, ` +
                //     `GSM: ${data[0].gsm}, BF: ${data[0].bf || 0}, ` +
                //     `ID/OD: ${data[0].core_id || 0} / ${data[0].reel_od || 0}, ` +
                //     `Roll.wt: ${data[0].achieved_qty || 0}(Mt), ` +
                //     `Reel Length: ${data[0].reel_length || 0} meters, ` +
                //     `Customer Number: ${data[0].customer_code || 'XXXXXXX'}`;

                //     const qrValue = `Child Roll No: ${data[0].child_reel_number || 'XXXXXX0123'}, ` ;

                // setQRCodeValue(qrValue);
            }
            else {

            }

        })
        .catch(error => {
            // Update state with error message        
            // setSheeterSeverityvalue('error');
            // setSheeterMessageValue(error.message);
            // setSheeterAlertTitleValue('Error');
            // setSheeterMsgOpen(true);
        });
}
export default LoadChildRollDetailsInQRCode;